import React, { useState } from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
// IMPORTANT: Named import for QrReader
import { QrReader } from 'react-qr-reader';
import Logo from "../../assets/images/logo.png"

const Home = () => {
  const [scanning, setScanning] = useState(false);
  const [scanResult, setScanResult] = useState('');

  // Start scanning
  const handleScanClick = () => {
    setScanning(true);
  };

  // Handle the scan result or error
  const handleScan = (result, error) => {
    if (result) {
      // result.text includes the scanned QR code data
      setScanResult(result?.text);
      setScanning(false); // Stop scanning on successful read
      window.location.href = result?.text;
    }
    if (error) {
      // If needed, handle or log errors here
      console.warn(error);
    }
  };

  return (
    <Container sx={{ textAlign: 'center',flex: 1, flexDirection: 'column', justifyContent: 'top', alignItems: 'center', display: 'flex', height: '100vh',width: '100vw', }}>
      {/* Heading */}
      <Box mb={4}>
        <img width='120px' height='120px' src={Logo} alt="secuber-logo"></img>
        <Typography variant="h4" component="h1" gutterBottom>
          Welcome!
        </Typography>
        <Typography variant="body1">
          Please scan the QR code to check in.
        </Typography>
      </Box>

      {/* Conditionally render either placeholder or actual scanner */}
      {!scanning ? (
        <Box>
          <QrCodeScannerIcon sx={{ fontSize: 80, color: 'primary.main' }} />
          {scanResult && (
            <Typography sx={{ mt: 2 }}>
              Last Scanned: <strong>{scanResult}</strong>
            </Typography>
          )}
        </Box>
      ) : (
        <>
          {/* QrReader from react-qr-reader v3 */}
          <QrReader
            onResult={handleScan}
            constraints={{ facingMode: 'environment' }}
            containerStyle={{ width: '100%' }}
            videoStyle={{ width: '100%' }}
          />
          {scanResult && (
            <Typography sx={{ mt: 2 }}>
              Scanned QR Code: <strong>{scanResult}</strong>
            </Typography>
          )}
        </>
      )}

      {/* Start scanning button */}
      <Box mt={4}>
        {!scanning && (
          <Button
            variant="contained"
            color="primary"
            startIcon={<QrCodeScannerIcon />}
            onClick={handleScanClick}
          >
            Scan Now
          </Button>
        )}
      </Box>
    </Container>
  );
};

export default Home;
